import BadgeNext from "ds/components/BadgeNext";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import Tile from "ds/components/Tile";
import TileTitle from "ds/components/Tile/Title";

import { IntegrationView } from "../../types";

type IntegrationCardProps = IntegrationView;

const IntegrationCard = ({
  id,
  name,
  description,
  icon,
  docsLink,
  hasViewScreen,
  isNew,
}: IntegrationCardProps) => {
  return (
    <Tile
      title={
        <TileTitle>
          <Box gap="medium" align="center">
            {name} {isNew && <BadgeNext variant="blue" type="strong" text="New" />}
          </Box>
        </TileTitle>
      }
      description={description}
      icon={icon}
      indicator={
        <LinkButton
          to={hasViewScreen ? `./${id}` : docsLink}
          variant="secondary"
          target={hasViewScreen ? undefined : "_blank"}
        >
          {hasViewScreen ? "View" : "Go to docs"}
        </LinkButton>
      }
    />
  );
};

export default IntegrationCard;
